import React, {Component} from 'react';
import {Row, Col} from "react-bootstrap";
import RozkladService from "../RozkladService";
import PokazRozkladForm from "./components/PokazRozkladForm";
import TrasyService from "../../../trasyConfig/trasy/TrasyService";
import KalendarzDoDatyService from "../../kalendarze/przypisanieKalendarzaDoDaty/KalendarzDoDatyService";
import DefinicjaGodzinyStartowejService from "../../definicjeGodzinStartowychjDlaTrasy/DefinicjaGodzinyStartowejService";
import DataFormat from "../../../../../utilities/DateAndTimeFormat";
import PokazRozkladTable from "./components/PokazRozkladTable";
import TopIf from "../../../../../componentsTopsa/if/TopIf";
import DefinicjeService from "../../../trasyConfig/definicjeTras/DefinicjeService";
import {TopAlertUwaga} from "../../../../../componentsTopsa/alerty/TopAlerts";
import PokazRozkladDodanieGodzinyForm from "./components/PokazRozkladDodanieGodzinyForm";
import ReactNotify from 'react-notify';


export default class PokazRozkladContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rozklad: [],
            trasy: [],
            params: '',
            iloscRekordow: -1,
            obecna_trasa: null,
            obecna_data: null,
            czyByloSzukanie: false,
            definicjeTras: [],
            pierwszy_przystanek: null,
            czyBylaZmianaSzukania:false,
        };
        this.pobierzTrasy = this.pobierzTrasy.bind(this)
        this.getKalendarzDoDaty = this.getKalendarzDoDaty.bind(this)
        this.getGodziny = this.getGodziny.bind(this)
        this.szukajGodzin = this.szukajGodzin.bind(this)
        this.szukajWRozkladzie = this.szukajWRozkladzie.bind(this)
        this.renderContent = this.renderContent.bind(this)
        this.onClickUsun = this.onClickUsun.bind(this)
        this.onClickZmianaGodziny = this.onClickZmianaGodziny.bind(this)
        this.onClickDodajKurs = this.onClickDodajKurs.bind(this)
        this.pobierzPierwszyPrzystanekNaTrasie = this.pobierzPierwszyPrzystanekNaTrasie.bind(this)
    }

    componentDidMount() {
        this.pobierzTrasy()
    }

    pobierzPierwszyPrzystanekNaTrasie(trasa){
            DefinicjeService.pobierzPierwszyPrzystanekNaTrasie(trasa.idTr).then(function (response) {
                this.setState({pierwszy_przystanek:response.data})
            }.bind(this))
    }

    pobierzTrasy() {
        TrasyService.getTrasy().then(function (response) {
            this.setState({trasy: response.data.content})
        }.bind(this))
    }

    getKalendarzDoDaty(trasa, data) {
        KalendarzDoDatyService.getDatyZKalendarzami(DataFormat.formatYYYYMMDD(data), DataFormat.formatYYYYMMDD(data)).then(function (response) {
            if (response.data.length > 0) {
                this.getGodziny(trasa.idTr, response.data[0].idRk)
            }
        }.bind(this))
    }

    getGodziny(trasa_id, kalendarz_id) {

        DefinicjaGodzinyStartowejService.getGodzinyWTrasieIKalendarzu(trasa_id, kalendarz_id).then(function (response) {
            this.setState({godziny: response.data})
        }.bind(this))

    }

    szukajGodzin(trasa, data) {
        this.getKalendarzDoDaty(trasa, data)
        this.setState({obecna_trasa: trasa, obecna_data: data, czyByloSzukanie: false})
        this.pobierzPierwszyPrzystanekNaTrasie(trasa)
    }

    szukajWRozkladzie(data, trasa, godzina) {
        this.setState({czyByloSzukanie: true})
        let params;
        if (data !== null && trasa !== null) {
            params = 'data=' + data + '&idTr=' + trasa.idTr;
        }
        if (data === null && trasa === null) {
            params = this.state.params
        }
        this.setState({params: params})
        RozkladService.getSzukajRozkladPierwszePrzystanki(0, 999999, params).then(function (response) {

            this.setState({rozklad: response.data.content, iloscRekordow: response.data.totalElements, czyBylaZmianaSzukania:true})
        }.bind(this))

    }

    renderContent() {
        if (this.state.iloscRekordow > 0) {

            return (<div>
                <PokazRozkladTable data={this.state.rozklad} pagination={false} handleUsun={this.onClickUsun}
                                   handleChangeGodzina={this.onClickZmianaGodziny} czyBylaZmianaSzukania={this.state.czyBylaZmianaSzukania} wylaczZmianeSzukania={()=>{this.setState({czyBylaZmianaSzukania:false})}}/>
            </div>)

        }
        else {
            return <div style={{height: '400px'}}><TopAlertUwaga text={'Nie znaleziono rekordów'}/></div>
        }
    }

    onClickUsun(obj) {
        if (window.confirm('Czy usunąc kurs nr. ' + obj.idKu + ' o ' + DataFormat.formatHHMM(obj.godz))) {
            RozkladService.usunGodzineRozkladPierwszePrzystanki(obj.idKu).then(function (response) {
                if (response.status < 300) {
                    this.refs.notificator.success("Pomyślnie usunięto kurs", "", 3000);
                    if (Boolean(this.state.params)) {
                        this.szukajWRozkladzie(null, null, null)
                    }
                }
                else {
                    this.refs.notificator.error("Wystąpił błąd podczas usuwania kursu ", "", 3000);
                }
            }.bind(this))
        }
    }

    onClickZmianaGodziny(godz, obj) {
        let data = {
            "data": obj.data,
            "godz": parseFloat(godz.replace(':', '.')),
            "idTr": obj.idTr,
            "nazPr": obj.nazPr,
            "nazTr": obj.nazTr,
            "idKu:": obj.idKu
        }

        RozkladService.edytujGodzineRozkladPierwszePrzystanki(obj.idKu, data).then(function (response) {
            if (response.status < 300) {
                this.refs.notificator.success("Pomyślnie edytowano kurs", "", 3000);
                if (Boolean(this.state.params)) {
                    this.szukajWRozkladzie(null, null, null)
                }
            }
            else {
                this.refs.notificator.error("Wystąpił błąd podczas edycji kursu ", "", 3000);
            }
        }.bind(this))

    }

    onClickDodajKurs(godz) {

        if (Boolean(godz) && Boolean(this.state.obecna_trasa) && Boolean(this.state.obecna_data)) {

            let data = {
                "data": DataFormat.formatYYYYMMDD(this.state.obecna_data),
                "godz": parseFloat(godz.replace(':', '.')),
                "idTr": this.state.obecna_trasa.idTr,
                "nazPr": Boolean(this.state.pierwszy_przystanek) ? this.state.pierwszy_przystanek.nazPr : '1szy przystanek',
                "nazTr": this.state.obecna_trasa.nazTr
            }

            RozkladService.dodajGodzineRozkladPierwszePrzystanki(data).then(function (response) {
                if (response.status < 300) {
                    this.refs.notificator.success("Pomyślnie dodano kurs", "", 3000);
                    if (Boolean(this.state.params)) {
                        this.szukajWRozkladzie(null, null, null)
                    }
                }
                else {
                    this.refs.notificator.error("Wystąpił błąd podczas dodawania kursu ", "", 3000);
                }
            }.bind(this))
        }
    }

    render() {

        return (
            <div>
                <ReactNotify ref='notificator'/>
                <Row>
                    <Col xs={12}>
                        <Row>
                            <Col xs={12} md={8}>
                                <PokazRozkladForm trasy={this.state.trasy}
                                                  handleSzukajGodzin={this.szukajGodzin}
                                                  godziny={this.state.godziny}
                                                  handleSzukaj={this.szukajWRozkladzie}
                                />
                            </Col>
                            <Col xs={12} md={4}>
                                <TopIf isTrue={Boolean(this.state.czyByloSzukanie)}>
                                    <PokazRozkladDodanieGodzinyForm handleClickDodajKurs={this.onClickDodajKurs}/>
                                </TopIf>
                            </Col>
                        </Row>
                    </Col>
                    <Col xs={12}>
                        {
                            (this.state.iloscRekordow > -1) ?
                                this.renderContent()
                                :
                                <div style={{height: '400px'}}></div>
                        }
                    </Col>
                    <Col xs={12}>
                        <div style={{height: '15px'}}></div>
                    </Col>
                </Row>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/rozkladConfig/rozklad/pokazRozklad/PokazRozkladContainer.js